import { Themes } from "@geist-ui/core";

const breakpoints = {
  xs: { min: '0', max: '650px' },
  sm: { min: '650px', max: '900px' },
  md: { min: '900px', max: '1280px' },
  lg: { min: '1280px', max: '1700px' },
  xl: { min: '1700px', max: '10000px' },
}

export const darkTheme = Themes.createFromDark({
  type: "solardark",
  breakpoints,
  palette: {
    background: "#2e3134",
    foreground: "#eef0f2",
  
    secondary: "#eef0f2",

    accents_1: "#f18303",
    accents_2: "#f18303",
    accents_3: "#2b2d2f",
    accents_4: "#333638",

    link: "#6fb1fc",
    selection: "#6fb1fc",

    // border: "#d7dadd"
  },
  expressiveness: {
    shadowSmall: "2px 2px 4px #2b2d2f, -2px -2px 4px #333638",
    shadowMedium: "4px 4px 8px #2b2d2f, -4px -4px 8px #333638",
    shadowLarge: "8px 8px 16px #2b2d2f, -8px -8px 16px #333638",
  }
});

export const lightTheme = Themes.createFromLight({
  type: "solarlight",
  breakpoints,
  palette: {
    background: "#eef0f2",
    foreground: "#2e3134",

    accents_1: "#f18303",
    accents_2: "#f18303",
    accents_4: "#dde0e1",
    accents_3: "#c6c9cc",

    link: "#f18303",
    selection: "#f18303",

    // border: "#2b2d2f"
  },
  expressiveness: {
    shadowSmall: "2px 2px 4px #c6c9cc, -2px -2px 4px #dde0e1",
    shadowMedium: "4px 4px 8px #c6c9cc, -4px -4px 8px #dde0e1",
    shadowLarge: "8px 8px 16px #c6c9cc, -8px -8px 16px #dde0e1",
  }
});